var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
export var Popup = function (props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return (_jsxs("div", __assign({ className: classnames("".concat(prefixCls, "-content"), className), style: style }, { children: [showArrow !== false && (_jsx("div", __assign({ className: "".concat(prefixCls, "-arrow") }, { children: arrowContent }), "arrow")), _jsx("div", __assign({ className: "".concat(prefixCls, "-inner"), id: id, role: "tooltip", style: overlayInnerStyle }, { children: typeof children === "function" ? children() : children }))] })));
};
export default Popup;
